import '../css/WhoWeAre.scss';
import { Link } from 'react-router-dom';

const WhoWeAre = () => (
  <section className="who-we-are-section">
    <div className="page-width who-we-are-inner">
      <div className="who-we-are-text">
        <span className="wwa-kicker">At The HoneyRock School</span>
        <h2>Who We Are</h2>
        <p>
          Founded in 2010 as a dedicated daycare, The Honeyrock School (THS) grew out of a simple
          passion: to provide children with a nurturing space to thrive. As our learners grew, we
          grew with them — evolving into a vibrant Preschool and expanding into a full Primary School
          by 2016.
        </p>
        <p>
          Today, THS is a premier educational institution in Lagos, Nigeria, trusted by families to
          deliver a world-class, global-standard education. We don't just teach; we lay the
          foundational stones for a lifetime of curiosity, character, and success.
        </p>
        <div className="wwa-accreditations">
          <p>The Honeyrock School is:</p>
          <ul>
            <li>Fully approved and recognised by the Ministry of Education</li>
            <li>Proudly affiliated with the Association of Christian Schools International (ACSI) Nigeria</li>
            <li>An active member of the National Association of Proprietors of Private Schools (NAPPS)</li>
          </ul>
        </div>
        <p className="wwa-promise">
          <strong>Our Promise:</strong> To give your child an outstanding foundation today, preparing
          them to lead and succeed in the world tomorrow.
        </p>
        <Link to="/about" className="wwa-link">Learn more about us</Link>
      </div>

      <div className="wwa-stats">
        <div className="wwa-stat">
          <span className="stat-number">2010</span>
          <span className="stat-label">Founded</span>
        </div>
        <div className="wwa-stat">
          <span className="stat-number">2016</span>
          <span className="stat-label">Full Primary School</span>
        </div>
        <div className="wwa-stat">
          <span className="stat-number">3</span>
          <span className="stat-label">Accreditations</span>
        </div>
        <div className="wwa-stat">
          <span className="stat-number">Lagos</span>
          <span className="stat-label">Nigeria</span>
        </div>
      </div>
    </div>
  </section>
);

export default WhoWeAre;
